require('./cardsBoxBody.scss');

// @ vendors
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const React = require('react');
const { withRouter } = require('react-router-dom');

// @core
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;

// @utilities
const { recordLink } = require('utilities/tagging');
const { cardValidationRules } = require('utilities/accessHelperConditions/cards');

// @commons
const { EmptyState } = require('commonsComponents/emptyState');
const { LastMovementsTable } = require('commonsComponents/lastMovementsTable');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKTableRow } = require('commonsComponents/OKTableRow');

// @ components
const CardBoxLastMovementsTableRow = require('components/cards/cardsBox/cardBoxLastMovementsTableRow/cardBoxLastMovementsTableRow');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const Sca = require('components/sca/sca');

// @constants
const { CARD_DEFERRABLE_PAYMENT, CARD_EXPANDED_TRANSACTIONS_LIMIT, CARD_CREDIT } = require('constants/index');
const { LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY } = require('constants/commonsComponents');
const { LAVANDA } = require('constants/flagBasedFeatures');
const {
    ACTION_EVENT_VIEW,
    DEFERRAL_PAYMENT_CARD_ACTION_EVENT,
    SEE_DETAILS_CARD_ACTION_EVENT,
    SEE_DETAILS_EVENT_TAG,
} = require('constants/tagging');
class CardsBoxBody extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            scaRequestModalVisible: false,
        };

        this.buildMovements = this.buildMovements.bind(this);
        this.buildScaSection = this.buildScaSection.bind(this);
        this.getTransactions = this.getTransactions.bind(this);
        this.handleRetry = this.handleRetry.bind(this);
        this.handlePostRequest = this.handlePostRequest.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        this.getTransactions();
    }

    componentWillReceiveProps(nextProps) {
        const { flagBasedFeatures, immCard, immCardsTransactions } = this.props;
        const { immCardsTransactions: nextImmCardsTransactions } = nextProps;

        const cardId = immCard.get('cardId');
        const immCardTransactions = immCardsTransactions.get(cardId);
        const nextImmCardTransactions = nextImmCardsTransactions.get(cardId);

        if (immCardTransactions && nextImmCardTransactions && !nextImmCardTransactions.get('scaRequired') && (immCardTransactions.get('byId').size !== nextImmCardTransactions.get('byId').size)) {
            const immTransactionsByOrder = nextImmCardTransactions.get('byOrder');
            const immTransactionsById = nextImmCardTransactions.get('byId');
            const size = immTransactionsByOrder.size;
            const transactionsCount = size > CARD_EXPANDED_TRANSACTIONS_LIMIT
                ? CARD_EXPANDED_TRANSACTIONS_LIMIT
                : size;
            let immTransactions;

            immTransactions = immTransactionsByOrder.take(transactionsCount).map(
                transactionId => immTransactionsById.get(transactionId)
            )
            if (cardValidationRules.CARD_PAYMENT_PURCHASE_DEFERRAL.validator({ immCard })){
                const atLeastOneDeferralPayment = immTransactions.some(transaction => transaction.get('deferPaymentIndicator') === CARD_DEFERRABLE_PAYMENT);
                flagBasedFeatures.get(LAVANDA) && atLeastOneDeferralPayment && recordLink(window.utag_last_name, DEFERRAL_PAYMENT_CARD_ACTION_EVENT, ACTION_EVENT_VIEW);
            }
        }
    }

    componentDidUpdate() {
        this.getTransactions();
    }

    getTransactions() {
        const { requestCardTransactions, immCardsTransactions, immCard } = this.props;
        const cardId = immCard.get('cardId');
        if (!immCardsTransactions.get(cardId) || !!immCardsTransactions.getIn([cardId,'error']) || immCardsTransactions.getIn([cardId,'isOutdated'])) {
            requestCardTransactions(cardId);
        }
    }

    buildCategoryTooltip() {
        const categoryFormattedText = (
            //Don't remove the span tag it fix a bug with the tooltip
            <span>
                <FormattedText value="cardsTransactions-category" format="firstUppercase" />
            </span>
        );
        return (
            <OKTooltip
                content="cardsTransactions-categoryTooltip"
                offset={[0, -15]}
                target={categoryFormattedText}
                type="descriptive"
            />
        );
    }

    buildConectionError() {
        const lostConnectionFirstLine = formatText('myMoneyTransactions-lostConnectionFirstLine');
        const retryButton = (
            <OKButton onClick={this.handleRetry}>
                <FormattedText value="myMoneyTransactions-retry"/>
            </OKButton>
        );

        return (
            <EmptyState
                button={retryButton}
                primaryText={lostConnectionFirstLine}
                iconType="nointernet-banking" />
        );
    }

    buildScaSection(immProfile, immCardTransactions, validateAndExecuteSagas) {
        return (
            <Sca
                isPreview
                onHandlePostRequest={this.handlePostRequest}
                immProfile={immProfile}
                immTransactions={immCardTransactions}
                validateAndExecuteSagas={validateAndExecuteSagas}
            />
        );
    }

    buildDateTooltip() {
        const dateFormattedText = (
            <span>
                <FormattedText value="cardsTransactions-date" format="firstUppercase" />
            </span>
        );
        return (
            <OKTooltip
                content="cardsTransactions-dateTooltip"
                offset={[0, -15]}
                target={dateFormattedText}
                type="descriptive"
            />
        );
    }

    buildEmptyState() {
        const messageFirstLine = formatText('cardsTransactions-emptyState');

        return (
            <EmptyState
                primaryText={messageFirstLine}
                iconType="nocard-banking"
            />
        );
    }

    buildMovements(immCardTransactions) {
        const { flagBasedFeatures, immCard, cardIndex } = this.props;
        const cardId = immCard.get('cardId');
        const immTransactionsByOrder = immCardTransactions.get('byOrder');
        const immTransactionsById = immCardTransactions.get('byId');
        const size = immTransactionsByOrder.size;
        const transactionsCount = (size > CARD_EXPANDED_TRANSACTIONS_LIMIT) ? CARD_EXPANDED_TRANSACTIONS_LIMIT : size;
        const linkId = `lnkCardDetails${cardIndex}`;
        const linkTo = `/myprofile/cards/${cardId}/movements`;
        const categoryTooltip = this.buildCategoryTooltip();
        const dateTooltip = this.buildDateTooltip();
        const language = getLanguage();

        let purchaseDeferralColumn;
        let columnsCount = 4;

        if (immCard.get('type') === CARD_CREDIT) {
            purchaseDeferralColumn = this.buildPurchaseDeferralColumn();
            columnsCount = 5;
        }

        let movements =  (
            <div className="cards-box-body__content">
                <LastMovementsTable
                    groupByDate={false}
                    rowComponent={CardBoxLastMovementsTableRow}
                    immTransactionsByOrder={immTransactionsByOrder.take(transactionsCount)}
                    immTransactionsById={immTransactionsById}
                    columnsCount={columnsCount}
                    id="cards-box-body-last-movements"
                    className="cards-box-body__movements"
                    currentMonthKey={LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY}
                    language={language}
                >
                    <thead>
                        <OKTableRow asHeader={true}>
                            <OKTableCell asHeader={true}>
                                {dateTooltip}
                            </OKTableCell>
                            <OKTableCell asHeader={true} className="cards-box-body__cell-header--category">
                                {categoryTooltip}
                            </OKTableCell>
                            <OKTableCell asHeader={true} className="cards-box-body__cell-header--description">
                                <FormattedText value="cardsTransactions-description" format="firstUppercase" />
                            </OKTableCell>
                            {purchaseDeferralColumn}
                            <OKTableCell asHeader={true} className="card-last-movements-table__cell-header--import">
                                <FormattedText value="cardsTransactions-amount" format="firstUppercase" />
                            </OKTableCell>
                        </OKTableRow>
                    </thead>
                </LastMovementsTable>
                <div className="cards-box-body__link-container">
                    <OKLink
                        modifier="editorial"
                        inverse={!__CONTACT_CENTER__}
                        id={linkId}
                        onClick={() => flagBasedFeatures.get(LAVANDA) && recordLink(window.utag_last_name, SEE_DETAILS_CARD_ACTION_EVENT, SEE_DETAILS_EVENT_TAG)}
                        to={linkTo}
                    >
                        <FormattedText value="cards-toDetails" />
                    </OKLink>
                </div>
            </div>
        );

        return movements;
    }

    buildPurchaseDeferralColumn() {
        return (
            <OKTableCell asHeader={true} className="cards-box-body__cell-header--deferrable">
                <FormattedText value="cardsTransactions-deferredPurchases" format="firstUppercase" />
            </OKTableCell>
        );
    }

    handleRetry() {
        this.getTransactions();
    }

    handlePostRequest() {
        const { history, immCard } = this.props;
        const cardId = immCard.get('cardId');
        history.push('/myprofile/cards/' + cardId + '/movements');
    }

    render() {
        const {
            immCardsTransactions,
            immCard,
            cardIndex,
            immProfile,
            validateAndExecuteSagas,
        } = this.props;

        const cardId = immCard.get('cardId');
        const immCardTransactions = immCardsTransactions.get(cardId);

        const cardBoxBodyId = 'cards-box-body' + cardIndex;

        const loading = !immCardTransactions || immCardTransactions.get('loading');
        const error = immCardTransactions && immCardTransactions.get('error');
        const empty = immCardTransactions && immCardTransactions.get('byOrder').size === 0;
        const scaRequired = immCardTransactions && immCardTransactions.get('scaRequired');

        let content;

        if (loading) {
            content = <LoadingSection />
        } else if (error) {
            content = this.buildConectionError();
        } else if (scaRequired) {
            content = this.buildScaSection(immProfile, immCardTransactions, validateAndExecuteSagas);
        } else if (empty) {
            content = this.buildEmptyState();
        } else {
            content = this.buildMovements(immCardTransactions);
        }


        return (
            <div className="cards-box-body" id={cardBoxBodyId}>
                {content}
            </div>
        );
    }
}

CardsBoxBody.propTypes = {
    cardIndex: PropTypes.number.isRequired,
    flagBasedFeatures: PropTypes.object,
    history: PropTypes.object.isRequired,
    immCard: PropTypes.object.isRequired,
    immCardsTransactions: PropTypes.object.isRequired,
    immProfile: PropTypes.object,
    requestCardTransactions: PropTypes.func.isRequired,
    validateAndExecuteSagas: PropTypes.func.isRequired,
};

module.exports = withRouter(CardsBoxBody);
